import { Tool } from '../../data/tools';

export const metadata: Tool = {
  id: 'trivia-quiz',
  name: 'Trivia & Quiz Challenger',
  description: 'Test your brain across multiple trivia categories, select difficulties, track scores, and challenge timers.',
  category: 'Brain Games',
  icon: 'Trophy',
  route: '/tools/trivia-quiz',
  metaTitle: 'Trivia & Quiz Challenger — Free General Knowledge Quiz Online',
  metaDescription: 'Challenge your brain with our free online trivia game. Choose from categories like History, Science, Pop Culture, and Games. Timed questions and instant scores.',
  keywords: [
    'trivia quiz online',
    'free trivia game',
    'general knowledge quiz',
    'brain challenger games',
    'history science trivia quiz',
    'opentdb trivia challenger',
    'interactive quiz timer'
  ],
  longDescription: 'The Trivia & Quiz Challenger queries open-source question databases to generate multiple-choice quizzes dynamically. Users can customize categories and difficulty levels, track correct and incorrect answer runs, and challenge their reaction time with an active question countdown.',
  howToUse: [
    'Choose your preferred category and difficulty tier from the settings panel.',
    'Click "Start Challenge" to initiate a 10-question trivia board.',
    'Select your answer before the progress countdown timer expires.',
    'Review your final score profile once the game completes.'
  ],
  benefits: [
    'Fetches questions dynamically from verified open-trivia registries.',
    'Includes gamified scoreboards and active timers to improve user metrics.',
    'Runs fully client-side on mobile and desktop without any login.'
  ],
  faq: [
    {
      question: 'How are the questions generated?',
      answer: 'Questions are retrieved from the Open Trivia Database (OpenTDB), a community-driven database containing thousands of verified multiple-choice questions.'
    },
    {
      question: 'Is there a limit on how many quizzes I can play?',
      answer: 'No! You can generate unlimited quizzes. If you play multiple times in a row, the database ensures fresh question selections.'
    },
    {
      question: 'Can I play this game offline?',
      answer: 'This challenger requires a working internet connection to fetch fresh question sets from the database. Once loaded, the active quiz board runs locally.'
    }
  ]
};
